export const ADJUST_SUITE_CUSTOM_LINK = 'https://ferryscanner.go.link/cNRrl';
